import styled from "styled-components";
import formatNumberToString from "../../../utils/formatNumber";

interface AccInterface {
    total_income: number
    total_sales: number
    total_commission: number
    total_daily_costs: number
    total_net_profit: number
    total_gross_profit: number
    total_real_income: number
    total_operation_costs: number
    total_traspass_income: number
}

export default function Accounting({total_commission, total_net_profit, 
    total_gross_profit, total_sales, total_income, 
    total_daily_costs, total_real_income, total_operation_costs,
    total_traspass_income
    }: AccInterface) {
    
    return (
        <Main>
            <span>Ingresos de operacion: ${formatNumberToString(total_income)}</span>
            <span>Ingresos reales de operacion: ${formatNumberToString(total_real_income)}</span>
            <span>Costos de operacion: ${formatNumberToString(total_operation_costs)}</span>
            <span>Ganancia de operacion ideal: ${formatNumberToString(total_income)}</span>
            <span>Ganancia de operacion real: ${formatNumberToString(total_real_income)}</span>
            <span>Ganancia de traspasos: ${formatNumberToString(total_traspass_income)}</span>
            <span>Total comision: ${formatNumberToString(total_commission)}</span>
            <span>Total ventas: ${formatNumberToString(total_sales)}</span>
            <span>Total daily costs: ${formatNumberToString(total_daily_costs)}</span>
            <span>Ganancia neta: ${formatNumberToString(total_net_profit)}</span>
            <span>Ganancia bruta: ${formatNumberToString(total_gross_profit)}</span>
        </Main>
    )
}

const Main = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
flex-wrap: wrap;
gap: 10px;
span {
    display: block;
    padding: 5px 10px;
    background-color: ${props => props.theme.yellowDark};
    color: ${props => props.theme.white};
}
`